
const currentApp = () => {
    const path = window.location.pathname.split('/',2);
    return path[1];
}

export default currentApp;